import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { help } from "../../constants/actionTypes";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import { errorApiDoc, successApiDoc } from "../actions/help";
import { getApiDocs } from "../api/help";

export function* getApiDocsSaga({ payload }) {
  try {
    const data = yield call(getApiDocs, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successApiDoc(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorApiDoc(data));
    }
  } catch (err) {
    yield put(errorApiDoc(err));
  }
}

export function* helpRootSaga() {
  yield takeLatest(help?.REQUEST_API_DOC, getApiDocsSaga);
}

export default function* rootSaga() {
  yield all([fork(helpRootSaga)]);
}
